import { createSelector } from 'reselect';
import { parentSelector } from '../../selectors/parentSelector';
import { ApplicableRestrictions } from './types';

export const getApplicableRestrictionsSlice = createSelector(
    parentSelector,
    (state): ApplicableRestrictions => state.data.applicableRestrictions
);
